import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';

export interface HomeMenuItemProps {
    className?: string;
    marginLeft?: number;
    label?: string;
}

export const HomeMenuItem = (props: HomeMenuItemProps) => (
    <LeftMenuItem
        icon="pe-7s-home"
        label={props.label ?? 'Home'}
        to="/user-home"
        flagCode={NotificationFlagsCategories.AnnouncementsCode}
        className={props.className}
        marginLeft={props.marginLeft}
        trackingAction="Home"
        gtmCategory="Home"
    />
);
